import angular from 'angular';
import originalImageComponent from './original-image.component';
import 'angular-filesize-filter/angular-filesize-filter';
import fancyBoxModule from '../../../../modules/fancybox-plus/fancybox-plus';
import publishToMedia from '../../../../modules/publish-to-media/publish-to-media';

import originalImageFallbackDirective from './original-image-fallback.directive';

let originalImageModule = angular.module('originalImage', [
    'ngFilesizeFilter',
    fancyBoxModule,
    publishToMedia
])

    .component('originalImage', originalImageComponent)
    .directive('originalImageFallback', originalImageFallbackDirective)

    .name;

let states = [
    {
        name: 'image',
        url: '/image/{id}?action',
        template: '<original-image set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-image>'
    },
    {
        name: 'imageHash',
        url: '/image/hash/{hash}',
        template: '<original-image set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-image>'
    },
    {
        name: 'imageReproduction',
        url: '/image/reproduction/{reproduction}',
        template: '<original-image set-error="$ctrl.setError(error)" set-reproduction="$ctrl.setReproduction(reproduction)" set-show-reproduction-detail="$ctrl.setShowReproductionDetail(show)" share-to-weixin="$ctrl.shareToWeixin(url)" app-user="$ctrl.appUser"></original-image>'
    }
];

export default {name: originalImageModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/original/original-image/original-image.js